// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table .avatar[data-v-4498f7b0] {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  vertical-align: middle;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\ntable tbody td.username span.el-tag[data-v-4498f7b0] {\n  float: right;\n}\n", ""]);
// Exports
module.exports = exports;
